import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import NameType from './NameType';
import PlusButton from '../../PlusButton';
import { DropdownOption, OrderEntryName, Property } from '../../types';
import produce from 'immer';
import { useOrderEntry } from '../../OrderEntryContext';
import AddAdditionalData from '../PropertyTab/AddAdditionalData';

const OuterStyles = styled.div`
  /* margin-top: 16px; */
  padding: 16px 0 32px 0;
  /* margin-left: 10%; */
  /* padding-left: 200px; */
`;
const OptionButton = styled.div<{ backgroundColor?: boolean }>`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  padding: 4px 8px;
  background-color: ${props => props.backgroundColor && '#e5e5ea'};
  margin-right: 8px;
  cursor: pointer;
`;
const ErrorText = styled.div`
  font-size: 13px;
  color: #c50e29;
`;
interface PropTypes {
  orderEntryNames: OrderEntryName[];
  setOrderEntryNames: React.Dispatch<React.SetStateAction<OrderEntryName[]>>;
  properties: Property[];
}

const Names = () => {
  const { orderEntryNames, setOrderEntryNames, properties, isPurchase, setIsPurchase, errors, fromAddressLookup } = useOrderEntry();

  const onChangeType = (option: DropdownOption, index: number) => {
    const newState = produce(orderEntryNames, draft => {
      draft[index].type = option;
    });
    setOrderEntryNames(newState);
  };
  const addName = () => {
    const newOther = produce(orderEntryNames, draft => {
      if (draft.length === 0) {
        draft.push({ name: '', type: { value: 1, label: 'Borrower' } });
      }
      else if (draft.length > 0 && !isPurchase){
        draft.push({ name: '', type: { value: 1, label: 'Borrower' } });
      }
      else {
        draft.push({ name: '', type: { value: 3, label: 'Other' } });
      }
    });
    setOrderEntryNames(newOther);
  };
  useEffect(() => {
    if (properties.length > 0) {
      const ownerNames = properties.map((p) => p.owners ).flat();
      const names = produce(orderEntryNames, draft => {
        const buyer = draft.find(name => name.type.value === 2);
        const seller = draft.find(name => name.type.value === 1 && (name.name || !fromAddressLookup));
        if (!seller) {
          ownerNames.forEach(ownerName => {
          draft.push({ name: ownerName, type: { value: 1, label: isPurchase ? 'Seller' : 'Borrower' } });         
          });
        }
        if (isPurchase && !buyer) {
          draft.push({ name: '', type: { value: 2, label: 'Buyer' } });
        }

      });

      setOrderEntryNames(names);
    }

  }, [JSON.stringify(properties)]);

  const onChangeName = (index: number) => (value: string) => {
    const newNames = produce(orderEntryNames, draft => {
      draft[index].name = value;
    });
    setOrderEntryNames(newNames);
  };

  const onChangeSaleType = (label: string) => {
    const newOrderNames = produce(orderEntryNames, draft => {
      for (let orderName of draft) {
        if (orderName.type.value === 1) {
          orderName.type.label = label;
        }
      }
      const buyerIndex = draft.findIndex(d => d.type.value === 2);
      if (label === 'Seller' && buyerIndex === -1) {
        draft.push({ name: '', type: { value: 2, label: 'Buyer' } });
      }
      if (label === 'Borrower' && buyerIndex > -1) {
        draft.splice(buyerIndex, 1);
      }
    });

    setOrderEntryNames(newOrderNames);
  };

  const onChangeOption = (index: number) => (value: DropdownOption) => {
    const newNames = produce(orderEntryNames, draft => {
      draft[index].type = value;
    });
    setOrderEntryNames(newNames);
  };

  const onDeleteName = (index: number) => {
    const newNames = produce(orderEntryNames, draft => {
      draft.splice(index, 1);
    });
    setOrderEntryNames(newNames);
  };

  if (properties.length === 0) {
    return <div></div>;
  }

  return (
    <OuterStyles>
      <div style={{ marginBottom: 10 }}>
        <div style={{ fontWeight: 'bold', paddingRight: 8, fontSize:16 }}>Names</div>
        <div style={{marginLeft:200}}>
          <div style={{display:'flex', marginBottom:16}}>
        <OptionButton
          backgroundColor={isPurchase}
          onClick={() => {
            setIsPurchase(true);
            onChangeSaleType('Seller');
          }}
        >
          Purchase
        </OptionButton>
        <OptionButton
          backgroundColor={!isPurchase}
          onClick={() => {
            setIsPurchase(false);
            onChangeSaleType('Borrower');
          }}
        >
          Refi
        </OptionButton>
      </div>


      {orderEntryNames.map((oen, index) => {
        return (
          <NameType
            nameOption={oen.type}
            defaultName={oen.type.label}
            name={oen.name}
            isPurchase={isPurchase}
            onChangeOption={onChangeOption(index)}
            deleteName={index >= 1}
            onChangeName={onChangeName(index)}
            onDelete={() => onDeleteName(index)}
          />
        );
      })}
       {errors?.titleNumber && <ErrorText>{errors?.names}</ErrorText>}
      <AddAdditionalData dataName="Add Name" styles={{ marginTop: 64 }} onClick={addName} />
      </div>
      </div>
    </OuterStyles>
  );
};

export default Names;